import { ApiService } from "@/api";

export const uploadMemberAttachment = (sampleId: string, form: File) => {
  return ApiService.baseAction(
    `sample-detail/member_attachment/${sampleId}`,
    {
      data: form
    },
    "post"
  );
};
